// Live agent todo-list (from SDK's TodoWrite tool). Each tick of the
// streaming `todos` event replaces the whole list — we render the latest.

import { Check, Circle, Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";
import type { TodoItem } from "@/lib/types";

export function TodoListCard({ todos }: { todos: TodoItem[] }) {
  if (!todos.length) return null;

  return (
    <div className="rounded-lg border border-border bg-card shadow-card p-4 space-y-2">
      <p className="text-tiny tracking-[0.18em] uppercase text-muted-foreground mb-2">
        Plan
      </p>
      <ul className="space-y-1.5">
        {todos.map((t, i) => (
          <li
            key={i}
            className={cn(
              "flex items-start gap-2.5 text-sm leading-snug",
              t.status === "completed" &&
                "text-muted-foreground line-through decoration-muted-foreground/40"
            )}
          >
            <span className="mt-0.5 shrink-0">
              {t.status === "completed" && (
                <Check className="h-4 w-4 text-green-600" />
              )}
              {t.status === "in_progress" && (
                <Loader2 className="h-4 w-4 text-[hsl(var(--inku-blue))] animate-spin" />
              )}
              {t.status === "pending" && (
                <Circle className="h-4 w-4 text-muted-foreground/40" />
              )}
            </span>
            <span>
              {t.status === "in_progress" && t.activeForm
                ? t.activeForm
                : t.content}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
